// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3J1K6","nameUser":"style_nameUser__UU9Lz"};